<script>
  import {userTier,user} from "../stores/stores.js";
  import {get} from "svelte/store";

  export let buyButtons = []; // Array of buy button objects { id, publishableKey }

  // Ensure the Stripe script is added to the document
  const loadStripeScript = () => {
    const existingScript = document.querySelector('script[src="https://js.stripe.com/v3/buy-button.js"]');

    if (!existingScript) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://js.stripe.com/v3/buy-button.js";
      document.body.appendChild(script);
    }
  };
  const userId = $user ? $user.localAccountId : null;

  loadStripeScript();
</script>
<style>
    .disabled {
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.5;
    }
</style>
{#each buyButtons as button (button.id)}
    <stripe-buy-button
            class:disabled={get(userTier) === button.tierLabel}
            buy-button-id={button.id}
            client-reference-id={userId}
            publishable-key={button.publishableKey}
    ></stripe-buy-button>
{/each}
